











































































































import { Component, Vue } from "vue-property-decorator";
import YcHeader from "@/components/common/yc-header.vue";
import YcAside from "@/components/common/yc-aside.vue";
import {getFlowCount, getGuideDetail, login, getToken, checkGuide} from "@/services/api";
import {DisplayInfo} from "@/model/UserInfo";
import store from "@/store";
import {defaultTimezone} from "@/services/config";
import JSEncrypt from "jsencrypt";
import {Alert} from "element-ui";

@Component({
  components: {
    "yc-aside": YcAside,
    "yc-header": YcHeader,
    "el-alert": Alert
  },
})
export default class Index extends Vue {
  show = false;
  showBrowerAlert = true;

  isPlanExpired = false; /* 到期 */
  isPlanExceed = false; /* 额度为0 */
  isPlanExceedShow = true;
  residualEmailCountPercent = false;  /* 额度不足5% */   /* 额度不足10% */
  residualEmailCountPercentShow5 = true;
  residualEmailCountPercentShow10 = true;
  residualEmailCountPercentNum = 0;
  shoplinePlanExpired = false; /* 快到期 */
  shoplinePlanExpiredShow=true;
  timeData=''

  created() {
    let token = localStorage.getItem("token");
    if (!token) {
      // this.$router.push('/login');
      process.env.NODE_ENV === 'production'?
        window.location.href = '/cartsee-new/login':
        this.loginDev();
    }
    if (this.$route.path.indexOf('/strategy/flow') === -1) {
        let newShow = localStorage.getItem('dns-needNotice') || 'false'
        this.show = JSON.parse(newShow)
      }

    const browserInfo = JSON.parse(localStorage.getItem('browserInfo') || '{}');
    const hiddenBrowserGuide = localStorage.getItem('browserGuideShow') === 'false';
    console.log(browserInfo, hiddenBrowserGuide);
    if (browserInfo.browser === 'chrome' || hiddenBrowserGuide) {
      this.showBrowerAlert = false;
    }
    /* 到期 */
    if(localStorage.getItem('isPlanExpired') == 'true'){
      this.isPlanExpired = true
    } 
    /* 额度为0 */
    if(localStorage.getItem('isPlanExceed') == 'true'){
      this.isPlanExceed = true
    } 
    /* 额度不足5% */   /* 额度不足10% */
    if(Number(localStorage.getItem('residualEmailCountPercent')) > 0 && Number(localStorage.getItem('residualEmailCountPercent')) <=10){
      let localNum = Number(localStorage.getItem('residualEmailCountPercent'))
      this.residualEmailCountPercent = true
      let num = 0
      if(localNum > 0 && localNum <= 5){
        num = 5
      }else if(localNum >0 && localNum <= 10){
        num = 10
      }
      this.residualEmailCountPercentNum = num
    }
    /* 快到期 */
    if(JSON.parse(localStorage.getItem('shoplinePlanExpired') || '{}')?.days){
      this.shoplinePlanExpired = true
      this.timeData = JSON.parse(localStorage.getItem('shoplinePlanExpired') || '{}')
    }
    /* 额度为0提醒------session */
    if(sessionStorage.getItem('isPlanExceedShow') == 'false'){
      this.isPlanExceedShow = false
    }
    /*额度不足5%或10%------session */
    if(sessionStorage.getItem('residualEmailCountPercentShow5') == 'false'){
      this.residualEmailCountPercentShow5 = false
    }
    if(sessionStorage.getItem('residualEmailCountPercentShow10') == 'false'){
      this.residualEmailCountPercentShow10 = false
    }
    /* 快到期------------session */
    if(sessionStorage.getItem('shoplinePlanExpiredShow') == 'false'){
      this.shoplinePlanExpiredShow = false
    }
  }
  handleAlertClose() {
    localStorage.setItem('browserGuideShow', 'false');
  }
  openUrl(item:any){
    window.open(item)
  }
  setSession1(item:string){
    sessionStorage.setItem('isPlanExceedShow', 'false');
    this.isPlanExceedShow = false
  }
  setSession2(){
    if(this.residualEmailCountPercentNum == 5){
      sessionStorage.setItem('residualEmailCountPercentShow5', 'false');
      this.residualEmailCountPercentShow5 = false
    }
    if(this.residualEmailCountPercentNum == 10){
      sessionStorage.setItem('residualEmailCountPercentShow10', 'false');
      this.residualEmailCountPercentShow10 = false
    }
  }
  setSession3(item:string){
    sessionStorage.setItem('shoplinePlanExpiredShow', 'false');
    this.shoplinePlanExpiredShow = false
  }
  async loginDev() {
    const formData = {
      email: 'test30_01@cartx.ai',
      password: '7l2FL15747'
    }

    // 创建加密对象实例
    const encrypt = new JSEncrypt();
    const pubKey = `MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCt+CcQrM1/WAotGUivgWJx5HKRJwKxweHzqvB4bBlNpURXoO3iDPS/RVgw44uAy8IXdWJNQyzHYOTZy4Mlc/Izox1jhFe3mI5whry89kuIRytShg2cvTuR0spuRFbljO4QoOOJELt9tirBb2mvmzyzNMlT3+isUqvC4ThXe5mD4QIDAQAB`;
    encrypt.setPublicKey(pubKey) //设置公钥
    const password = encrypt.encrypt(formData.password)|| '';  // 对内容进行加密

    const res1 = await login({ email: formData.email, password}, true);
    if (res1.data && res1.data.code === 0) {
      // todo 和displayInfo一样在vuex里设置
      localStorage.setItem('token', res1.data.data.token);
      const displayInfo: DisplayInfo = {name: res1.data.data.name, email: formData.email};
      sessionStorage.setItem('sessionDisplayInfo', JSON.stringify(displayInfo));
      store.commit('SET_DISPLAY_INFO', displayInfo);
    } else {
      this.$message.error(res1.data.message);
      return
    }

    let defaultPath = '/guide';
    const res2 = await getGuideDetail({},true);
    // todo 和displayInfo一样在vuex里设置
    localStorage.setItem('timezone', res2.data.data.companyInfo.timezone|| defaultTimezone);
    const companyInfo = res2.data.data.companyInfo;
    store.commit('SET_COMPANY_INFO', companyInfo);
    if (res2.data.data.nextStep === -1) {
      defaultPath = '/home';
      const res3 = await getFlowCount({}, true);
      if(res3.data.data === 0) {
        defaultPath = '/account/settings';
        store.commit('SET_FLOW_COUNT', res3.data.data);
      }
    } else {
      store.commit('SET_TEMPLATE_INFO', res2.data.data);
    }

    const redirect: any = defaultPath === '/guide'? defaultPath : (this.$route.query.redirect || defaultPath);
    this.$router.replace(redirect);
  }
}
